module.exports = __webpack_public_path__ + "img/qijian-fenzu.815bbb28.svg";